import React from 'react';
interface ReceiptDetailsProps {
  customerName: string;
  paymentMethod: string;
  paymentTime: string;
  remarks: string;
}
export function ReceiptDetails({
  customerName,
  paymentMethod,
  paymentTime,
  remarks
}: ReceiptDetailsProps) {
  return <div className="mb-8" data-id="element-1040">
      <div className="grid grid-cols-[180px_1fr] gap-x-8 gap-y-2.5 text-sm" data-id="element-1041">
        <div className="text-xs font-semibold text-neutral-700" data-id="element-1042">
          Received From:
        </div>
        <div className="text-sm font-medium text-neutral-900" data-id="element-1043">
          {customerName}
        </div>

        <div className="text-xs font-semibold text-neutral-700" data-id="element-1044">
          Payment Time:
        </div>
        <div className="text-sm text-neutral-900" data-id="element-1045">{paymentTime}</div>

        <div className="text-xs font-semibold text-neutral-700" data-id="element-1046">Remarks:</div>
        <div className="text-sm text-neutral-900 whitespace-pre-line" data-id="element-1047">
          {remarks}
        </div>
      </div>
    </div>;
}